<template>
  <div v-if="images?.length" class="fe-flex fe-items-center fe-w-full">
    <!-- Image Thumbnails -->
    <div class="fe-flex fe-gap-xs">
      <LazyImage
        v-for="(image, index) in images"
        :key="image.id"
        :src="image.lowResUrl"
        placeholder="none"
        :alt="'Review Image ' + (index + 1)"
        @click="handleClick(image.id)"
        class-name="fe-w-huge fe-h-huge fe-cursor-pointer fe-rounded-medium"
      />
    </div>
  </div>
</template>

<script>
  import LazyImage from "@/components/DesignSystem/LazyImage/LazyImage.vue"

  export default {
    name: "ReviewImages",
    components: {
      LazyImage,
    },
    props: {
      review: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      images() {
        return this.review.images || []
      },
    },
    methods: {
      handleClick(imageId) {
        this.$emit("click", imageId)
      },
    },
  }
</script>
